import { CLEAR_RETURNS, FETCH_GSTR1, FETCH_SUB_GSTR } from '../../../../Helper/actionsTypes'

export const returnsReducer = (state = [], action) => {
    const { results, code } = action.payload || ''
    switch (action.type) {
        case FETCH_GSTR1: {
            return code === 200
                ? { ...state, gstr1: results }
                : { ...state, gstr1: null }
        }
        case FETCH_SUB_GSTR: {
            return code === 200
                ? { ...state, sub: results }
                : { ...state, sub: null }
        }
        case 'RETURN_DATE': {
            return { ...state, date: action.payload }
        }
        case CLEAR_RETURNS: {
            return { ...state, gstr1: null, sub: null }
        }
        default: return state
    }
}